import type { PatientSessionRevocationReason } from "@care-by-ella/contracts";

// TES-1205 — support's "Logga ut patienten från alla enheter". The reason is
// a fixed code (it goes into the audit log, where free text never goes), so
// the dialog offers these and nothing else.

export const SESSION_REVOCATION_REASON_LABEL: Record<
  PatientSessionRevocationReason,
  string
> = {
  lost_device: "Telefonen är borttappad eller stulen",
  patient_request: "Patienten bad om det",
  suspected_misuse: "Misstänkt obehörig åtkomst",
};

export function patientSessionsRevokePath(
  apiBase: string,
  patientId: string,
): string {
  return `${apiBase}/employee-api/v1/patients/${encodeURIComponent(patientId)}/sessions/revoke`;
}
